import {
  getIsThemePreview,
  getPortalAccountId,
  getPortalInstanceId,
  getPreviewJwt,
} from './utils/metadata';
// @ts-ignore Untyped module
import Cookies from 'js-cookie';

type ClientInfo = {
  accountId?: number;
  portalInstanceId?: number;
  previewJwt?: string;
};

const isThemePreview = getIsThemePreview();
const previewJwt = getPreviewJwt();

export default function createPortalsFetchClient(prefix: string) {
  return function portalsFetchClient(
    input: RequestInfo | URL,
    init: RequestInit | undefined
  ) {
    const originalBody = JSON.parse(init!.body!.toString());
    let clientInfo: ClientInfo = {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId(),
    };
    if (isThemePreview) {
      clientInfo = { previewJwt };
    }
    return fetch(`${prefix}${input}`, {
      method: 'POST',
      headers: {
        ...init!.headers,
        'X-Hs-Membership-Csrf':
          Cookies.get('__Host-hs-membership-csrf') ??
          Cookies.get('hs-membership-csrf'),
      },
      body: JSON.stringify({ ...originalBody, ...clientInfo }),
    });
  };
}
